/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vtp_Link_Error_Order_Has_ShipmentInputs */

const vi_vtp_link_error_order_has_shipment = /** @type {(inputs: Vtp_Link_Error_Order_Has_ShipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn hàng này đã có vận đơn`)
};

/**

* @param {Vtp_Link_Error_Order_Has_ShipmentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vtp_link_error_order_has_shipment = /** @type {((inputs?: Vtp_Link_Error_Order_Has_ShipmentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vtp_Link_Error_Order_Has_ShipmentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vtp_link_error_order_has_shipment(inputs)
});